import { ArrowDropDown, ArrowDropUp, ArrowUpward, Circle, CreditCard, NorthEast, SouthWest, Upcoming, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  Fab,
  IconButton,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { green, grey, orange, red } from "@mui/material/colors";
import { LineChart } from "@mui/x-charts/LineChart";
import { useState } from "react";

function Landing() {


    const [visible, setVisible] = useState(false)
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Stack display={"flex"}>
          <Typography variant="h6">Banking</Typography>
          <Box display={"flex"} alignItems={"center"} columnGap={1}>
            <Typography>Total Balance</Typography>
            <Button variant="outlined" size="small" sx={{borderRadius:4, ml: "auto" }}>Send</Button>
            <Button variant="outlined" size="small" sx={{borderRadius:4}}>Request</Button>
            <Button variant="outlined" size="small" sx={{borderRadius:4}}>New Account</Button>
          </Box>
          <Box display={"flex"} alignItems={"center"}>
            <Typography variant="h5" ml={6} sx={{fontWeight:'bold'}}>68500</Typography>
          </Box>
          <Box display={"flex"} alignItems={"center"} columnGap={2}>
            <Card sx={{ width: "75vw" }}>
              <CardContent>
              <Card sx={{bgcolor:grey[200]}}>
                <CardContent sx={{display:"flex", flexDirection:"row", padding:1}}>
              <Card sx={{width:'50%'}}>
              <CardContent sx={{display:"flex", flexDirection:'column'}}>
                <Chip color="success" label={<Typography><ArrowDropUp/>8.55</Typography>} sx={{ml:"auto"}}/>
                <Box display={'flex'}>
                    <Fab ><SouthWest /></Fab>
                    <Stack ml={2}>
                        <Typography variant="body1" color={grey[500]}>Income</Typography>
                        <Typography variant="h6">Ksh. 895245</Typography>
                    </Stack>
                </Box>
                </CardContent>
              </Card>
              <Card sx={{width:'50%',bgcolor:grey[200]}} elevation={0}>
              <CardContent sx={{display:"flex", flexDirection:'column'}}>
                <Chip color="error" label={<Typography><ArrowDropDown/>8.55</Typography>} sx={{ml:"auto"}}/>
                <Box display={'flex'}>
                    <Fab ><NorthEast /></Fab>
                    <Stack ml={2}>
                        <Typography variant="body1" color={grey[500]}>Expenses</Typography>
                        <Typography variant="h6">Ksh. 562548</Typography>
                    </Stack>
                </Box>
                </CardContent>
              </Card>
              </CardContent>
              </Card>
                <Typography variant="h6">Trends</Typography>
                <Box display={"flex"}>
                  <LineChart
                    xAxis={[{ data: [1, 2, 3, 4, 5, 6, 8, 9, 10] }]}
                    series={[
                      {
                        data: [220, 55, 250, 850, 150, 500],
                        area: false,
                        showMark:false,
                      },
                    ]}
                    width={800}
                    height={300}
                    grid={{horizontal:true}}
                  />
                </Box>
              </CardContent>
            </Card>
            <Stack display={'flex'} rowGap={1}>
              <Card elevation={2} sx={{ width: "25vw" }}>
                <CardContent sx={{ bgcolor: grey[900] }}>
                  <Typography variant="h6" color={grey[50]}>Bank 1</Typography>
                  <Typography variant="body2" color={grey[400]}>
                    Current balance 
                  </Typography>
                  <Box display={'flex'} my={1}>
                    {visible? <Chip label={<Typography variant="body1" color={grey[400]}>
                    25000
                  </Typography>} />:<Chip label={<Typography variant="body1" color={grey[400]}>
                    *******
                  </Typography>} />}
                    <IconButton  onClick={()=>setVisible(!visible)} size="small"  >{visible?<VisibilityOff color={grey[50]}/>:<Visibility color={grey[50]}/>}</IconButton>
                  </Box>
                  <Box display={'flex'} my={1}>
                    <Typography variant="h6" color={grey[50]} ml={"auto"}><CreditCard/>  **********245</Typography>
                  </Box>
                  <Box display={'flex'} my={1} justifyContent={'space-evenly'}>
                    <Stack  display={'flex'}>
                    <Typography variant="body2" color={grey[400]}>
                    Card holder
                  </Typography>
                  <Typography variant="h6" color={grey[50]} ml={"auto"}>  Kadesea</Typography>
                    </Stack>
                    <Stack  display={'flex'}>
                    <Typography variant="body2" color={grey[400]}>
                    Expiry
                  </Typography>
                  <Typography variant="h6" color={grey[50]} ml={"auto"}>  2/2025</Typography>
                    </Stack>
                  </Box>
                 
                  <Divider variant="middle" ><Button variant="outlined" size="small" sx={{borderRadius:4}}>All transactions</Button></Divider>
                </CardContent>
                
              </Card>
              
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </Zoom>
  );
}

export default Landing;
